import { Webhook } from 'lucide-react'
import { Link, useLocation } from 'react-router'
import { WebhookSwitcher } from '@/components/layout/breadcrumbs/webhook/webhook-switcher'
import {
  BreadcrumbItem,
  BreadcrumbPage,
  BreadcrumbLink,
  BreadcrumbSeparator,
} from '@/components/ui/breadcrumb'
import {
  Tooltip,
  TooltipTrigger,
  TooltipContent,
} from '@/components/ui/tooltip'
import { useCompanyPath } from '@/lib/hooks'

const WebhooksIconBreadcrumbItem = () => {
  const { getCompanyPath } = useCompanyPath()
  return (
    <BreadcrumbItem>
      <Link to={getCompanyPath({ pathname: '/webhooks' })}>
        <Tooltip delayDuration={1000}>
          <BreadcrumbPage className="cursor-pointer p-2 flex items-center rounded-md text-muted-foreground hover:bg-muted hover:text-foreground">
            <TooltipTrigger>
              <BreadcrumbLink asChild>
                <div className="cursor-pointer">
                  <Webhook className="size-3.5" />
                  <span className="sr-only">Webhooks</span>
                </div>
              </BreadcrumbLink>
            </TooltipTrigger>
          </BreadcrumbPage>
          <TooltipContent sideOffset={8}>
            <span>Webhooks</span>
          </TooltipContent>
        </Tooltip>
      </Link>
    </BreadcrumbItem>
  )
}

export const WebhookBreadcrumbs = () => {
  const { pathname } = useLocation()

  return (
    <>
      {pathname === '/webhooks' ? (
        <BreadcrumbItem>
          <BreadcrumbPage className="flex items-center gap-2 px-2">
            <Webhook className="size-3.5" />
            <span className="font-medium">Webhooks</span>
          </BreadcrumbPage>
        </BreadcrumbItem>
      ) : null}
      {pathname === '/webhooks/create' ? (
        <>
          <WebhooksIconBreadcrumbItem />
          <BreadcrumbSeparator />
          <BreadcrumbItem>
            <BreadcrumbPage className="px-2 font-medium">
              Create webhook
            </BreadcrumbPage>
          </BreadcrumbItem>
        </>
      ) : null}
      {pathname.startsWith('/webhook/') ? (
        <>
          <WebhooksIconBreadcrumbItem />
          <BreadcrumbSeparator />
          <WebhookSwitcher />
        </>
      ) : null}
    </>
  )
}
